import React from 'react';
import AdminContent from 'components/root/admin/AdminContent';

export const AdminPage: React.FC = () => {
  return <AdminContent />;
};
